import React from 'react';
import ReportTemplateModel, { ReportTemplateModelNames } from './ReportTemplateModel';

const SqlsList = () => {
    return (
        <ReportTemplateModel
            modelName={ReportTemplateModelNames.Sql}            
        />
    );
}
export default React.memo(SqlsList);
